<template>
  <div class="h-100">
    <div class="row f-row justify-content-center">
      <div class="col col-11">
        <div class="row f-row justify-content-center bdr-b">
          <div class="col col-2 txt-label-primary-2 text-center">
            <table class="table table-sm table-borderless trade_process_table">
              <thead class="table-headers text-center align-center thead">
                <tr>
                  <th>
                    PROCESS
                    <div
                      class="warning-trade-div-2 text-center"
                      v-if="showWarningQuoteDiv"
                    >
                      Select and calculate strategy
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="col col-8 txt-label-primary-2 text-center">
            <table class="table table-sm table-borderless trade_process_table">
              <thead class="table-headers text-center align-center thead">
                <tr>
                  <th>COUNTERPARTY</th>
                  <th>QUOTE SENT</th>
                  <th>ACCEPTED</th>
                  <th>QUOTE RECEIVED</th>
                  <th>RANK</th>
                  <th>SELECT</th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="col col-2 txt-label-primary-2 text-center">
            <table class="table table-sm table-borderless trade_process_table">
              <thead class="table-headers text-center align-center thead">
                <tr>
                  <th>
                    HEDGE
                    <div
                      class="warning-trade-div-2 text-center"
                      v-if="showWarningTradeDiv"
                    >
                      Quote and select counterparty
                    </div>
                    <div
                      class="warning-trade-div-2 text-center"
                      v-if="showWarningSelectedBankDiv"
                    >
                      Selection did not provide the best quote
                    </div>
                    <i
                      v-show="readyToTrade && selectedBankBool"
                      class="fa fa-warning warn-my-data ml-1"
                      @mouseover="onHoverWarningSelectedBank(true)"
                      @mouseleave="onHoverWarningSelectedBank(false)"
                    ></i>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row f-row justify-content-center">
      <div
        class="col col-11 h-100"
        style="height: calc(30vh - 81px)!important;"
      >
        <div
          class="row f-row justify-content-center"
          style="height: calc(30vh - 81px)!important;"
        >
          <div class="col col-2 txt-label-primary-2 text-center h-100">
            <button
              style="position: absolute"
              type="button"
              class="btn btn-process"
              v-on:click="onUserPreQuote"
              :disabled="nBanks === 0 || !readyToQuote || processStage !== 0"
            >
              <span v-if="processStage === 0">REQUEST<br />FOR QUOTE</span>
              <span v-else-if="processStage === 1"
                >ELAPSED<br />{{ quoteElapsed }}</span
              >
              <span
                v-else-if="processStage === 2"
                style="color: var(--textactive)"
                >FINISHED<br />{{ quoteElapsed }}</span
              >
            </button>
            <button
              v-show="processStage !== 0"
              type="button"
              class="btn btn-cancel-process"
              v-on:click="onUserCancelPreQuote"
            >
              <i class="fa fa-times"></i>
            </button>
            <div
              class="modal-trader"
              v-if="!readyToQuote"
              @mouseover="onHoverWarningQuote(true)"
              @mouseleave="onHoverWarningQuote(false)"
            ></div>
          </div>
          <div
            style="vertical-align: middle!important; overflow: auto;"
            class="col col-8 text-center h-100"
          >
            <table
              class="table table-sm table-borderless trade_process_table trade_process_table_h"
            >
              <tbody class="table-headers text-center align-center thead">
                <tr v-for="(item, index) in newBanks" :key="index" class="tr">
                  <td class="text-left">
                    <label class="checkbox_container">
                      <input
                        type="checkbox"
                        name="checkbox_select"
                        :value="index"
                        v-model="item.include"
                        @click="onClientBankInclude"
                      />
                      <span class="checkbox_checkmark"></span>
                      <span
                        class="ml-2"
                        v-bind:class="{ 'light-background-txt': !item.include }"
                        >{{ item.name }}</span
                      >
                    </label>
                  </td>
                  <td>
                    <span
                      style="border: none!important;"
                      v-bind:class="[
                        item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                    <v-progress-circular
                      :indeterminate="animate && item.state === 0"
                      :value="95"
                      :rotate="5"
                      :color="
                        getColor(
                          item.state + animate * 10 * (item.state === 0),
                          1
                        )
                      "
                      :size="25"
                      :width="3"
                    >
                      <i
                        class="fa fa-times fnt-sm"
                        v-show="item.state === -1"
                      ></i>
                      <i
                        class="fa fa-check fnt-sm"
                        v-show="item.state >= 1"
                      ></i>
                    </v-progress-circular>
                    <span
                      v-bind:class="[
                        item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                  </td>
                  <td>
                    <span
                      v-bind:class="[
                        item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                    <v-progress-circular
                      :indeterminate="animate && item.state === 1"
                      :value="95"
                      :rotate="5"
                      :color="
                        getColor(
                          item.state + animate * 10 * (item.state === 1),
                          2
                        )
                      "
                      :size="25"
                      :width="3"
                    >
                      <i
                        class="fa fa-times fnt-sm"
                        v-show="item.state === -1"
                      ></i>
                      <i
                        class="fa fa-check fnt-sm"
                        v-show="item.state >= 2"
                      ></i>
                    </v-progress-circular>
                    <span
                      v-bind:class="[
                        item.state >= 2 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                  </td>
                  <td>
                    <span
                      v-bind:class="[
                        item.state >= 2 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                    <v-progress-circular
                      :indeterminate="animate && item.state === 2"
                      :value="95"
                      :rotate="5"
                      :color="
                        getColor(
                          item.state + animate * 10 * (item.state === 2),
                          3
                        )
                      "
                      :size="25"
                      :width="3"
                    >
                      <i
                        class="fa fa-times fnt-sm"
                        v-show="item.state === -1"
                      ></i>
                      <i
                        class="fa fa-check fnt-sm"
                        v-show="item.state >= 3"
                      ></i>
                    </v-progress-circular>
                    <span
                      v-bind:class="[
                        item.state >= 3 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                  </td>
                  <td class="text-center">
                    <span
                      v-bind:class="[
                        item.state >= 3 ? 'h-line-expo' : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                    <span>
                      <v-progress-circular
                        :indeterminate="animate && item.state === 4"
                        :value="95"
                        :rotate="5"
                        :color="
                          getColor(
                            item.state + animate * 10 * (item.state === 3),
                            3
                          )
                        "
                        :size="25"
                        :width="3"
                      >
                        <i
                          class="fa fa-question fnt-sm"
                          v-if="item.rank === null && item.state !== -1"
                        ></i>
                        <i
                          class="fa fa-times fnt-sm"
                          v-if="item.state === -1"
                        ></i>
                        <span v-else>{{ item.rank }}</span>
                      </v-progress-circular>
                    </span>
                    <span
                      v-bind:class="[
                        item.state >= 3 && item.rank === 1
                          ? 'h-line-expo'
                          : 'h-line-gray'
                      ]"
                      >&nbsp;</span
                    >
                  </td>
                  <td>
                    <label class="radio_container">
                      <input
                        :disabled="item.state === -1"
                        type="radio"
                        name="radio_select"
                        :value="index"
                        v-model="selectedBank"
                        @click="onClientBankSelect(item.id)"
                      />
                      <span class="radio_checkmark"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col col-2 txt-label-primary-2 text-center h-100">
            <button
              type="button"
              class="btn btn-process"
              v-on:click="onUserTrade"
              :disabled="nBanks === 0 || !readyToTrade"
            >
              SEND<br />ORDER
            </button>
            <div
              class="modal-trader"
              v-if="!readyToTrade"
              @mouseover="onHoverWarningTrade(true)"
              @mouseleave="onHoverWarningTrade(false)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { colorExpo, lightBackground } from "@/_core/_helpers/_parametric_tools";
import { sum } from "d3";

export default {
  name: "QuoteProcessTable",
  props: {
    banks: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    processStage: { required: true, default: 0 },
    quoteElapsed: { required: true, default: null },
    readyToQuote: { required: true, type: Boolean, default: false },
    readyToTrade: { required: true, type: Boolean, default: false },
    selectedBank: { required: true, default: -1 }
  },
  data() {
    return {
      newBanks: [],
      showWarningQuoteDiv: false,
      showWarningTradeDiv: false,
      showWarningSelectedBankDiv: false,
      animate: false,
      interval: null
    };
  },
  created() {
    this.newBanks = this.banks;
  },
  computed: {
    selectedBankBool() {
      if (this.selectedBank < 0) {
        return false;
      } else if (this.newBanks.length - 1 >= this.selectedBank) {
        return this.newBanks[this.selectedBank].rank !== 1;
      } else {
        return false;
      }
    },
    quotesMissing() {
      let mssng = 0;
      this.newBanks.forEach(function(d) {
        mssng = mssng + d.state >= 3 ? 0 : 1;
      });
      return mssng;
    },
    nBanks() {
      return sum(this.newBanks, function(d) {
        return d.include === true ? 1 : 0;
      });
    }
  },
  watch: {
    processStage(val) {
      if (val === 1) {
        let _this = this;
        this.interval = setInterval(() => {
          _this.animate = !_this.animate;
        }, 2000);
      } else {
        clearInterval(this.interval);
        this.animate = false;
      }
    },
    banks(val) {
      this.newBanks = val;
    },
    readyToQuote(val) {
      if (val === true) {
        this.showWarningQuoteDiv = false;
      }
    }
  },
  methods: {
    onClientBankInclude() {
      this.$emit("eventOnClientBankInclude", this.newBanks);
    },
    onClientBankSelect(idx) {
      this.$emit("eventOnClientBankSelect", idx);
    },
    onUserPreQuote() {
      this.$emit("eventOnUserPreQuote", "QUOTE");
    },
    onUserCancelPreQuote() {
      this.$emit("eventOnUserCancelPreQuote");
    },
    onUserTrade() {
      console.log("trade");
    },
    getColor(num, ref) {
      return num >= ref
        ? colorExpo(this.colorTheme)
        : lightBackground(this.colorTheme);
    },
    onHoverWarningQuote(val) {
      this.showWarningQuoteDiv = val;
    },
    onHoverWarningTrade(val) {
      this.showWarningTradeDiv = val;
    },
    onHoverWarningSelectedBank(val) {
      this.showWarningSelectedBankDiv = val;
    }
  }
};
</script>

<style scoped>
/* radio checkboxes */
.radio_container {
  width: 20px;
  display: block;
  position: relative;
  top: -6px;
  left: calc(50% - 7px);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default radio button */
.radio_container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.radio_checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: var(--lightbackground);
  border-radius: 50%;
}
/* On mouse-over, add a grey background color */
.radio_container:hover input ~ .radio_checkmark {
  background-color: var(--lightbackground2);
}
/* When the radio button is checked, add a blue background */
.radio_container input:checked ~ .radio_checkmark {
  background-color: var(--lightbackground);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.radio_checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.radio_container input:checked ~ .radio_checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.radio_container .radio_checkmark:after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--expo);
}

/* checkbox checkboxes */
.checkbox_container {
  width: 100%;
  display: block;
  position: relative;
  left: calc(25% - 7px);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default checkbox button */
.checkbox_container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkbox_checkmark {
  position: absolute;
  top: 3px;
  left: -14px;
  height: 14px;
  width: 14px;
  background-color: var(--lightbackground);
  border-radius: 2%;
}
/* On mouse-over, add a grey background color */
.checkbox_container:hover input ~ .checkbox_checkmark {
  background-color: var(--lightbackground2);
}
/* When the checkbox button is checked, add a blue background */
.checkbox_container input:checked ~ .checkbox_checkmark {
  background-color: var(--lightbackground);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkbox_checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.checkbox_container input:checked ~ .checkbox_checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.checkbox_container .checkbox_checkmark:after {
  content: "\2714";
  font-size: 0.75rem;
  top: -2px;
  left: 2px;
  color: var(--expo);
}
</style>
